"use strict";

import Drift from 'drift-zoom';
import { LuminousGallery } from 'luminous-lightbox';
import Panzoom from '@panzoom/panzoom';
import exportedVars from 'main.scss';

const drifts = [],
    $window = $(window);

$window.on('load resize', function () {
    if ($window.width() >= parseInt(exportedVars.driftZoomBreakpoint)) {
        if (drifts.length === 0) {
            $('.catalogue-gallery-image').each(function (i, img) {
                const $paneContainer = $(img).closest('.product-gallery').find('.drift-zoom-pane-container');
                drifts[i] = new Drift(img, {
                    sourceAttribute: 'data-src-hires',
                    paneContainer: $paneContainer[0],
                    onShow: function () {
                        $paneContainer.removeClass('d-none');
                    },
                    onHide: function () {
                        // Stop from overlaying other elements, once again
                        $paneContainer.addClass('d-none');
                    },
                    injectBaseStyles: false,
                    hoverBoundingBox: true,
                });
            });
        }
    } else {
        if (drifts.length > 0) {
            // Disable drifts on mobile, to allow scrolling by touching
            // the image
            $.each(drifts, function (i, drift) {
                drift.destroy();
            });
            drifts.splice(0, drifts.length);
        }
    }
});

export default function galleryImage(scrollProperties) {
    new LuminousGallery(document.querySelectorAll('.catalogue-gallery-image'), {
        arrowNavigation: true,
    }, {
        sourceAttribute: 'data-src-hires',
        onOpen: function() {
            Panzoom(document.querySelector('.lum-lightbox-image-wrapper'), {
                panOnlyWhenZoomed: true,
            });
        },
    });

    $('.catalogue-gallery-thumbnails a').on('click', function (e) {
        e.preventDefault();
    });

    const galleries = $('.catalogue-gallery');

    galleries.each(function (i, gallery) {
        const $gallery = $(gallery);
        const $items = $gallery.find('.catalogue-gallery-image, .catalogue-gallery-video');
        const $thumbnails = $gallery.find('.catalogue-gallery-thumbnails-switcher-items');
        const $thumbnailItems = $thumbnails.find('li');
        const $prevButton = $gallery.find('.catalogue-gallery-thumbnails-prev');
        const $nextButton = $gallery.find('.catalogue-gallery-thumbnails-next');

        let currentIndex = 0;
        const itemWidth = $thumbnailItems.outerWidth(true);
        const visibleItems = Math.floor($thumbnails.parent().width() / (itemWidth + 5));
        const maxIndex = $thumbnailItems.length - visibleItems;

        function scrollThumbnails(index) {
            const scrollAmount = index * itemWidth;
            $thumbnails.animate(scrollProperties(scrollAmount), 300);
        }

        $prevButton.on('click', function (e) {
            if (currentIndex > 0) {
                currentIndex--;
                scrollThumbnails(currentIndex);
            }
        });

        $nextButton.on('click', function (e) {
            if (currentIndex < maxIndex) {
                currentIndex++;
                scrollThumbnails(currentIndex);
            }
        });

        $thumbnailItems.on('mouseenter', function () {
            let $this = $(this);
            let index = $this.index();

            $thumbnailItems.removeClass('active');
            $items.removeClass('active');

            $this.addClass('active');
            $items.eq(index).addClass('active');
        });
    });
}
